export var CalculLink;
(function (CalculLink) {
    CalculLink["Cr"] = "CR";
    CalculLink["Bfr"] = "BFR";
    CalculLink["Caf"] = "CAF";
    CalculLink["Pf"] = "PF";
    CalculLink["Tva"] = "TVA";
    CalculLink["Prets"] = "PRETS";
    CalculLink["None"] = "NONE";
    CalculLink["Bilancedant"] = "BILANCEDANT";
    CalculLink["PretsPasses"] = "PRETS_PASSES";
})(CalculLink || (CalculLink = {}));
export var Category;
(function (Category) {
    Category["Employment"] = "EMPLOYMENT";
    Category["Environment"] = "ENVIRONMENT";
    Category["Governance"] = "GOVERNANCE";
    Category["Social"] = "SOCIAL";
    Category["Territory"] = "TERRITORY";
    Category["Other"] = "OTHER";
})(Category || (Category = {}));
export var ContactType;
(function (ContactType) {
    ContactType["Entrepreneur"] = "ENTREPRENEUR";
    ContactType["Partner"] = "PARTNER";
    ContactType["Contact"] = "CONTACT";
})(ContactType || (ContactType = {}));
export var CopyNoteStatus;
(function (CopyNoteStatus) {
    CopyNoteStatus["Ok"] = "OK";
    CopyNoteStatus["Partial"] = "PARTIAL";
})(CopyNoteStatus || (CopyNoteStatus = {}));
export var FrontEventType;
(function (FrontEventType) {
    FrontEventType["Error"] = "ERROR";
})(FrontEventType || (FrontEventType = {}));
export var InvolvementProfile;
(function (InvolvementProfile) {
    InvolvementProfile["NoInvolvement"] = "NO_INVOLVEMENT";
    InvolvementProfile["Ecolo"] = "ECOLO";
    InvolvementProfile["Employer"] = "EMPLOYER";
    InvolvementProfile["Ethics"] = "ETHICS";
    InvolvementProfile["Social"] = "SOCIAL";
    InvolvementProfile["Territorial"] = "TERRITORIAL";
    InvolvementProfile["MultiCommitted"] = "MULTI_COMMITTED";
    InvolvementProfile["Other"] = "OTHER";
})(InvolvementProfile || (InvolvementProfile = {}));
export var InvolvementProfileV2;
(function (InvolvementProfileV2) {
    InvolvementProfileV2["NegativeImpact"] = "NEGATIVE_IMPACT";
    InvolvementProfileV2["NeutralImpact"] = "NEUTRAL_IMPACT";
    InvolvementProfileV2["PositiveImpact"] = "POSITIVE_IMPACT";
})(InvolvementProfileV2 || (InvolvementProfileV2 = {}));
export var LabelKeys;
(function (LabelKeys) {
    LabelKeys["BonusCriterion"] = "BONUS_CRITERION";
    LabelKeys["BonusCriterionDescription"] = "BONUS_CRITERION_DESCRIPTION";
    LabelKeys["IcExample_0"] = "IC_EXAMPLE_0";
    LabelKeys["IcExample_1"] = "IC_EXAMPLE_1";
    LabelKeys["IcExample_2"] = "IC_EXAMPLE_2";
    LabelKeys["IcExample_3"] = "IC_EXAMPLE_3";
})(LabelKeys || (LabelKeys = {}));
export var Lifecycle;
(function (Lifecycle) {
    Lifecycle["Emergence"] = "EMERGENCE";
    Lifecycle["Creation"] = "CREATION";
    Lifecycle["Reprise"] = "REPRISE";
    Lifecycle["Development"] = "DEVELOPMENT";
    Lifecycle["Rebound"] = "REBOUND";
    Lifecycle["Scale"] = "SCALE";
})(Lifecycle || (Lifecycle = {}));
export var NoteType;
(function (NoteType) {
    NoteType["Creation"] = "CREATION";
    NoteType["Reprise"] = "REPRISE";
    NoteType["StructureExistante"] = "STRUCTURE_EXISTANTE";
    NoteType["UndefinedCreation"] = "UNDEFINED_CREATION";
})(NoteType || (NoteType = {}));
export var PaCategory;
(function (PaCategory) {
    PaCategory["Environment"] = "ENVIRONMENT";
    PaCategory["Position"] = "POSITION";
    PaCategory["Means"] = "MEANS";
    PaCategory["Entrepreneur"] = "ENTREPRENEUR";
})(PaCategory || (PaCategory = {}));
export var PaSubCategory;
(function (PaSubCategory) {
    PaSubCategory["MarketDemand"] = "MARKET_DEMAND";
    PaSubCategory["MarketSupply"] = "MARKET_SUPPLY";
    PaSubCategory["Competitors"] = "COMPETITORS";
    PaSubCategory["EnvironmentSynthesis"] = "ENVIRONMENT_SYNTHESIS";
    PaSubCategory["ProductOrService"] = "PRODUCT_OR_SERVICE";
    PaSubCategory["CommercialStrategy"] = "COMMERCIAL_STRATEGY";
    PaSubCategory["PositioningSynthesis"] = "POSITIONING_SYNTHESIS";
    PaSubCategory["Governance"] = "GOVERNANCE";
    PaSubCategory["OtherMeans"] = "OTHER_MEANS";
    PaSubCategory["MeansSynthesis"] = "MEANS_SYNTHESIS";
    PaSubCategory["Motivations"] = "MOTIVATIONS";
    PaSubCategory["AnalyzeMotivations"] = "ANALYZE_MOTIVATIONS";
    PaSubCategory["AnalyzeFinances"] = "ANALYZE_FINANCES";
    PaSubCategory["Savings"] = "SAVINGS";
    PaSubCategory["Synthesis"] = "SYNTHESIS";
})(PaSubCategory || (PaSubCategory = {}));
export var PeriodType;
(function (PeriodType) {
    PeriodType["Previsionnel"] = "PREVISIONNEL";
    PeriodType["Anterieur"] = "ANTERIEUR";
    PeriodType["Intermediaire"] = "INTERMEDIAIRE";
})(PeriodType || (PeriodType = {}));
export var PlanFinancementEntryType;
(function (PlanFinancementEntryType) {
    PlanFinancementEntryType["Besoins"] = "BESOINS";
    PlanFinancementEntryType["Apports"] = "APPORTS";
    PlanFinancementEntryType["Primes"] = "PRIMES";
    PlanFinancementEntryType["SubventionsInvestissements"] = "SUBVENTIONS_INVESTISSEMENTS";
    PlanFinancementEntryType["PretsAt"] = "PRETS_AT";
    PlanFinancementEntryType["PretsHorsAtGarantis"] = "PRETS_HORS_AT_GARANTIS";
    PlanFinancementEntryType["PretsHorsAtNonGarantis"] = "PRETS_HORS_AT_NON_GARANTIS";
    PlanFinancementEntryType["CreditRelaisTva"] = "CREDIT_RELAIS_TVA";
})(PlanFinancementEntryType || (PlanFinancementEntryType = {}));
export var PretType;
(function (PretType) {
    PretType["Bancaire"] = "BANCAIRE";
    PretType["NonBancaire"] = "NON_BANCAIRE";
})(PretType || (PretType = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType["Question"] = "QUESTION";
    QuestionType["ExcludeCriteria"] = "EXCLUDE_CRITERIA";
    QuestionType["Prevention"] = "PREVENTION";
})(QuestionType || (QuestionType = {}));
export var Role;
(function (Role) {
    /** Administration role */
    Role["Admin"] = "ADMIN";
    /** Advisor role */
    Role["Advisor"] = "ADVISOR";
    /** Any *of the two* */
    Role["Any"] = "ANY";
})(Role || (Role = {}));
export var Units;
(function (Units) {
    Units["Euros"] = "EUROS";
    Units["KEuros"] = "K_EUROS";
    Units["Jours"] = "JOURS";
    Units["Month"] = "MONTH";
    Units["None"] = "NONE";
})(Units || (Units = {}));
export var YodaOrigin;
(function (YodaOrigin) {
    YodaOrigin["Pf"] = "PF";
    YodaOrigin["Bilan"] = "BILAN";
    YodaOrigin["Prets"] = "PRETS";
    YodaOrigin["NoteParams"] = "NOTE_PARAMS";
})(YodaOrigin || (YodaOrigin = {}));
//# sourceMappingURL=types.js.map